<template>
  <div>
    <form-modal
      :id="componente"
      titulo-botao-previsto="Inserir previsão"
      titulo-botao="Inserir despesa"
      :titulo-modal="configuracao.titulo"
      titulo-tabela-imutavel="Planejado"
      :colunas-imutaveis="configuracao.previsao"
      :dados-imutaveis="previstoCalculado"
      titulo-tabela-mutavel="Realizado"
      :colunas-mutaveis="colunasRealizado"
      :dados-mutaveis="realizadoCalculado"
      ref="modalForm"
      :criar="permissao.c && projetoEditavel"
      :ler="permissao.r"
      :atualizar="permissao.u"
      :remover="permissao.d && projetoEditavel"
      controles
      :esconder-realizado="!projetoIniciado"
      @ok="salvar"
      @cancel="inicializarForm"
      @editar="editar"
      @remover="deletar"
      @baixarComprovantes="baixarComprovantes"
      :botao-ok-vira-cancelar="!projetoEditavel"
      :somente-ok="!projetoEditavel"
    >
      <template #titulo-modal>
        <div v-if="projetoIniciado">
          <span class="mr-2">
            {{ configuracao.titulo }}
          </span>

          <b-badge> Total previsto: </b-badge>
          <b-badge class="ml-2" variant="light">
            {{ totalPrevisto }}
          </b-badge>

          <b-badge variant="warning" class="ml-4"> Total realizado: </b-badge>
          <b-badge class="ml-2" variant="light">
            {{ totalRealizado }}
          </b-badge>

          <b-badge variant="success" class="ml-4"> Total restante: </b-badge>
          <b-badge class="ml-2" variant="light">
            {{ totalRestante }}
          </b-badge>
        </div>
      </template>

      <template #modal>
        <component
          :is="componenteModal"
          ref="modal"
          :projeto="projeto"
          :form="form"
          :tipo-label="configuracao.tipo.label"
          :tipo-options="configuracao.tipo.options"
          @baixarArquivoAWS="baixarArquivoAWS"
        />
      </template>
    </form-modal>
  </div>
</template>
<script>
import FormModal from "../componentes/FormModal";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import config from "./config";
import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import cloneDeep from "lodash/cloneDeep";
import helpers from "@/common/utils/helpers";

export default {
  mixins: [AlertasMixin],
  components: {
    FormModal,
    st: () => import("./modal/previsto"),
    mc: () => import("./modal/previsto"),
    vd: () => import("./modal/vd"),
    ou: () => import("./modal/previsto"),
    ct: () => import("./modal/previsto"),
    auditoria: () => import("./modal/previsto"),

    realizado: () => import("./modal/realizado"),
  },
  props: {
    componente: {
      type: String,
      default: null,
    },
    projeto: {
      type: Object,
      default: null,
    },
    chavePermissao: {
      type: String,
      default: null,
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    previsto: [],
    realizado: [],
    colunasRealizado: [],
    form: null,
  }),
  mounted() {
    this.colunasRealizado = [
      {
        key: "dataEmissao",
        label: "Data",
        formatter: (value) => {
          if (value) return helpers.formatarDataBr(value);
        },
      },
      {
        key: "tipoDocumento",
        label: "Tipo de doc.",
        formatter: (value) => {
          if (value) return helpers.getEnum(value).text;
        },
      },
      { key: "numeroDocumento", label: "Nº doc." },
      { key: "descricao", label: "Descrição" },
      { key: "beneficiado", label: "Beneficiado" },
      {
        key: "valorIndividual",
        label: "Valor total",
        formatter: (value, label, item) => {
          if (item.id == -1) return helpers.formatarValor(item.valorIndividual);
          if (value)
            return helpers.formatarValor(
              item.valorIndividual * item.quantidade
            );
        },
      },
      { key: "actions", label: "Ações" },
    ];
  },
  methods: {
    montar: function () {
      this.inicializarForm();
      this.buscar(false);
      this.buscar(true);
    },
    inicializarForm: function () {
      if (!this.projetoIniciado) {
        this.form = cloneDeep(this.configuracao.form);
      } else {
        this.form = {
          descricao: null,
          justificativa: null,
          quantidade: 0,
          valorIndividual: "",
          valorUnitario:0,
          origemDespesa: null,
          despesaLaboratorioExistente: null,
          despesaLaboratorioNovo: null,
          dataEmissao: null,
          tipoDocumento: 0,
          numeroDocumento: null,
          documento: null,
          cpfcnpj: null,
          comprovanteBase64: null,
          comprovanteArquivo: null,
          comprovanteAWS: null,
          liquidacaoFinanceiraBase64: null,
          liquidacaoFinanceiraArquivo: null,
          liquidacaoFinanceiraAWS: null,
        };
      }
    },
    salvar: function () {
      let form = cloneDeep(this.form);
      if (!this.$refs.modal.validateState()) return;

      this.confirmar("Deseja salvar despesa?").then((confirmado) => {
        if (!confirmado) return;
        
        if(form.comprovanteArquivo) {
          form.comprovanteAWS = form.comprovanteArquivo;
          delete form['comprovanteArquivo'];
        }
        if(form.liquidacaoFinanceiraArquivo) {
          form.liquidacaoFinanceiraAWS = form.liquidacaoFinanceiraArquivo;
          delete form['liquidacaoFinanceiraArquivo'];
        }

        if (form.valor) form.valor = helpers.removerValor(form.valor);
        if (form.valorUnitario)
        form.valorUnitario = helpers.removerValor(form.valorUnitario);
        if (form.valorIndividual)
        {
          form.valorIndividual = helpers.removerValor(form.valorIndividual);
        }
        if (form.cpfcnpj) form.cpfcnpj = form.cpfcnpj.replace(/[^0-9]/g, "");
        if (form.dataEmissao) {
          if (form.dataEmissao.indexOf("/") > -1)
            form.dataEmissao = helpers.formatarDataBD(form.dataEmissao);
        }

        if (this.telaProponente) {
          form.projetoGestaoId = this.projeto.id;
        } else {
          form.projetoGestaoCooperadaId = this.projeto.id;
        }

        this.$store.dispatch(START_LOADING);
        ProjetoGestaoService.salvarDespesa(
          this.configuracao.endpoint,
          form,
          this.projetoIniciado,
          this.telaProponente ? "ProjetoGestao" : "ProjetoGestaoCooperada"
        )
          .then(() => {
            this.alertaSucesso("Despesa salva com sucesso!").then(() => {
              this.$refs.modalForm.closeModal();
              this.montar();
            });
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.alertaErro(err.response.data.errors);
            } else this.alertaErro("Erro ao salvar");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },
    editar: function (despesa) {
      this.form = cloneDeep(despesa);
      if (this.form.valor)
        this.form.valor = helpers.formatarValor(this.form.valor);
      if (this.form.valorUnitario)
      this.form.valorUnitario = helpers.formatarValor(this.form.valorUnitario);
      if (this.form.valorIndividual)
      this.form.valorIndividual = helpers.formatarValor(
        this.form.valorIndividual 	
        );
      if (this.form.dataEmissao)
        this.form.dataEmissao = helpers.formatarDataBr(this.form.dataEmissao);
      this.$refs.modalForm.openModal();
    },
    deletar: function (despesa) {
      this.confirmar("Deseja excluir despesa?").then((confirmado) => {
        if (!confirmado) return;

        this.$store.dispatch(START_LOADING);
        ProjetoGestaoService.excluirDespesa(
          this.configuracao.endpoint,
          despesa.id,
          this.projetoIniciado
        )
          .then(() => {
            this.alertaSucesso("Despesa excluida com sucesso!").then(() => {
              this.montar();
            });
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.alertaErro(err.response.data.errors);
            } else this.alertaErro("Erro ao excluir");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },
    buscar: function (realizado) {
      this.$store.dispatch(START_LOADING);
      ProjetoGestaoService.buscarDespesa(
        this.configuracao.endpoint,
        this.projeto.id,
        realizado,
        this.telaProponente ? "ProjetoGestao" : "ProjetoGestaoCooperada",
        this.telaProponente ? "ProjetoGestaoId" : "ProjetoGestaoCooperadaId"
      )
        .then((res) => {
          if (realizado) this.realizado = res.data.data.itens;
          else this.previsto = res.data.data.itens;
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    baixarComprovantes: function () {
      ProjetoGestaoService.baixarComprovanteRubricas(
        this.projeto.id,
        this.configuracao.endpoint
      )
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/zip" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `comprovantes_${this.configuracao.endpoint}.zip`;
          link.click();
        })
        .catch((err) => {
          if (err.response.status == 400) {
            const blob = new Blob([err.response.data], {
              type: "application/json",
            });
            const fr = new FileReader();
            fr.onload = (e) => {
              this.alertaErro(JSON.parse(e.target.result).errors);
            };
            fr.readAsText(blob);
          } else this.alertaErro("Erro ao baixar");
        });
    },
    baixarArquivoAWS: function(id, arquivoTipo){
      this.$store.dispatch(START_LOADING);

      ProjetoGestaoService.downloadArquivoDespesa(
        this.configuracao.endpoint, 
        id, 
        arquivoTipo
        )
          .then(response => {
            helpers.baixarArquivo(response.data, response.headers);
            this.alertaSucesso("Download do Arquivo Concluido!");               
          })
          .catch(err => {
            console.log(err);
            this.alertaErro("Erro ao fazer Download do Arquivo");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
    },
  },
  computed: {
    componenteModal: function () {
      return this.projetoIniciado ? "realizado" : `${this.componente}`;
    },
    configuracao: function () {
      let projeto = this.telaProponente
        ? this.projeto
        : this.projeto.projetoGestao;
      config.setInicio(
        !projeto.faseRealizacao
          ? `${projeto.anoInicio}-04-01`
          : projeto.dataInicio,
        projeto.faseRealizacao
      );
      let configuracao = config[this.componente];
      return configuracao;
    },
    projetoIniciado: function () {
      return this.telaProponente
        ? this.projeto.faseRealizacao
        : this.projeto.projetoGestao.faseRealizacao;
    },

    totalPrevisto: function () {
      if (!this.projetoIniciado) return "";

      if (this.componente == "vd") {
        return helpers.formatarValor(
          this.previsto.reduce(
            (total, el) => total + el.valorUnitario * el.quantidade,
            0
          )
        );
      } else {
        return helpers.formatarValor(
          this.previsto.reduce((total, el) => total + el.valor, 0)
        );
      }
    },
    totalRealizado: function () {
      if (!this.projetoIniciado) return "";

      let formulario =
        this.form.quantidade * helpers.removerValor(this.form.valorIndividual);
      return helpers.formatarValor(
        this.realizado.reduce((total, el) => {
          if (this.form.id == el.id) return total;
          return total + el.valorIndividual * el.quantidade;
        }, 0) + formulario
      );
    },
    totalRestante: function () {
      if (!this.projetoIniciado) return "";

      let formulario =
        this.form.quantidade * helpers.removerValor(this.form.valorIndividual);

      let totalPrevisto = 0;
      if (this.componente == "vd") {
        totalPrevisto = this.previsto.reduce(
          (total, el) => total + el.valorUnitario * el.quantidade,
          0
        );
      } else {
        totalPrevisto = this.previsto.reduce(
          (total, el) => total + el.valor,
          0
        );
      }

      let totalRealizado = this.realizado.reduce((total, el) => {
        if (this.form.id == el.id) return total;
        return total + el.valorIndividual * el.quantidade;
      }, 0);

      return helpers.formatarValor(
        totalPrevisto - (totalRealizado + formulario)
      );
    },

    previstoCalculado: function () {
      let value = cloneDeep(this.previsto);
      if (this.componente == "vd") {
        value.push({
          id: -1,
          tipo: -1,
          valorUnitario: this.previsto.reduce(
            (total, el) => total + el.valorUnitario * el.quantidade,
            0
          ),
          _rowVariant: "warning",
        });
      } else {
        value.push({
          id: -1,
          tipo: -1,
          valor: this.previsto.reduce((total, el) => total + el.valor, 0),
          _rowVariant: "warning",
        });
      }
      return value;
    },

    realizadoCalculado: function () {
      let value = cloneDeep(this.realizado);
      value.push({
        id: -1,
        valorIndividual: this.realizado.reduce((total, el) => {
          return total + el.valorIndividual * el.quantidade;
        }, 0),
        _rowVariant: "warning",
      });
      return value;
    },

    telaProponente: function () {
      return this.$route.name == "projeto-gestao-proponente-detalhamento";
    },

    permissao() {
      return this.$store.getters["app/retornaPermissao"](this.chavePermissao);
    },
  },
};
</script>
<style lang=""></style>
